module.exports = __webpack_public_path__ + "static/media/15.3ed26fa8.jpeg";